<template>
    <span
        :class="{ 'fill': inheritFill }"
        class="svg-sprite"
        aria-hidden="true"
        v-html="svg"
    />
</template>

<script>
export default {
    name: 'SVGSprite',
    props: {
        name: {
            type: String,
            required: true
        },
        inheritFill: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        svg() {
            return require(`images/sprite/${this.name}.svg`);
        }
    }
};
</script>

<style lang="scss">
.svg-sprite {
    display: inline-block;

    svg {
        width: 100%;
        height: auto;
    }

    &.fill {
        svg {
            path,
            rect {
                fill: currentColor;
                transition: fill 0.1s ease-in-out;
            }
        }
    }
}
</style>
